import React, { useState, lazy, Suspense } from "react";
import RatesSection from "./RatesSection";
import PartnerBenefits from "./PartnerBenefits";
import ApplyNow from "./ApplyNow";
import WhySunWest from "./WhySunWest";
import PricingTable from "./PricingTable";
import { Spinner } from "react-bootstrap";

const AnchorLink = lazy(() => import('react-anchor-link-smooth-scroll'));
const ApplyNowForm = lazy(() => import('./ApplyNowForm'));

export default function Body() {
    const [download, setDownload] = useState(false);

    //Below function check if the user already submitted the form and allow it to  download the spreadsheet.
    const setDownloadState = (downloadForm) => {
        setDownload(downloadForm);
    }

    return(
        <div>
             {/* <PricingTable downloadRateSheet={download} /> */}
            <RatesSection />
            <PartnerBenefits />
            <Suspense fallback={<div className="text-center"><Spinner /></div>}>
                <AnchorLink href="#applyNowForm" style={{
                    textDecoration: 'none'
                }}>
                    <ApplyNow btnTitle="Learn More" />
                </AnchorLink>
            </Suspense>
            {/* <WhySunWest /> */}
            <Suspense fallback={<div className="text-center"><Spinner /></div>}>
                <ApplyNowForm setDownloadState={setDownloadState} />
            </Suspense>
           
        </div>
    );
}